import { Component, Vue, Prop } from 'vue-property-decorator';
import WithRender from './FaskhVerificationComponent.html';
import { ValidationModel } from './Model/ValidationModel';
import { Inject } from 'vue-di-container';
import { GenerateVerificationResponse } from './Model/GenerateVerificationResponse';
import { UserVerfiedModel } from './Model/UserVerfiedModel';
import { Toaster } from '@/services/toast';
import FaskhVerificationService from './FaskhVerificationService';
import './FaskhVerificationComponent.scss';

@WithRender
@Component({
  components: {
    // HGDatePicker,
  },
  diProvide: [FaskhVerificationService],
})
export default class FaskhVerificationComponent extends Vue {
  @Inject(FaskhVerificationService)
  public faskhVerificationService!: FaskhVerificationService;
  public userOTP: string = '';
  @Prop({ default: null })
  public verifierIdentityNumber: string | any;

  @Prop({ default: 4 })
  public otpLength: number | any;

  public showResendButton: boolean = false;
  public showVerfyButton: boolean = true;
  public intervalTimer: any;
  public validationModel: ValidationModel = {
    dateOfBirth: '',
    idNumber: null,
  };
  public selectedTime: number = 0;
  public verfiyAnonymousUserDialog: boolean = false;
  private generateVerificationResponse:
    | GenerateVerificationResponse
    | any = null;

  public async verifyUser() {
    this.validationModel = {
      dateOfBirth: '',
      idNumber: null,
    };
    let fakeotp = this.$appConfig.FakeOtp.Enabled;
  

    this.generateVerificationResponse = await this.faskhVerificationService.oldIdentify();
 

    if (this.generateVerificationResponse.isSuccessful) {
      this.countdown(this.generateVerificationResponse.duration);
      this.verfiyAnonymousUserDialog = true;

      this.$nextTick(function () {
        let el: Element = document.getElementsByClassName(
          'otp-field-box--0'
        )[0];
        if (el) {
          setTimeout(() => {
            (el as HTMLElement).focus();
          });
        }
      });
    } else {
      Toaster.error(this.generateVerificationResponse.errorMessage);
    }
  }
  public close() {
    this.userOTP = '';
    this.verfiyAnonymousUserDialog = false;
  }

  public toggleResendButton() {
    this.showResendButton = !this.showResendButton;
  }

  public toggleVerfyButton() {
    this.showVerfyButton = !this.showVerfyButton;
  }
  public verify() {
    if (this.userOTP.length > 3) {
      const userVerfiedModel: UserVerfiedModel = {
        userOTP: this.userOTP,
        verificationToken: this.generateVerificationResponse.token,
        expiresAt: this.generateVerificationResponse.expiresAt,
      };
      this.$emit('userVerified', userVerfiedModel);
      this.userOTP = '';
    } else {
      Toaster.error('الرجاء إدخال رمز صحيح');
    }
  }
  public get calcMaxDateFrom() {
    const date = new Date();
    date.setTime(date.getTime());
    return (
      date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
    );
  }
  public onDateOfBirthPicked(date: string) {
    this.validationModel.dateOfBirth = date;
  }
  public countdown(seconds: number) {
    this.selectedTime = seconds;
    this.showResendButton = false;
    this.showVerfyButton = true;
    if (this.intervalTimer) {
      clearInterval(this.intervalTimer);
    }
    this.intervalTimer = setInterval(() => {
      this.selectedTime = this.selectedTime - 1;
      if (this.selectedTime === 0) {
        this.generateVerificationResponse = null;
        clearInterval(this.intervalTimer);
        this.showResendButton = true;
        this.showVerfyButton = false;
      }
    }, 1000);
  }
  public resend() {
    this.verifyUser();
    this.showResendButton = false;
    this.showVerfyButton = true;
  }

  checkInvalidDigits(event: any) {
    var invalidChars = ['-', '+', 'e', 'E'];
    if (invalidChars.includes(event.key)) {
      event.preventDefault();
      return false;
    }
  }
}
